import React, { useEffect } from 'react';
import PrivateRoutes from './route/PrivateRoutes';
import { ToastContainer } from 'react-toastify';

function App() {

  return (
    <div className="App">
      <PrivateRoutes />
      <ToastContainer />
    </div>
  );
}

export default App;
